import React from 'react'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    header: {
        /* background-color: var(--primary-color); */
        paddingTop: '30px',
        paddingBottom: '20px',
        textAlign: 'center',
        backgroundColor: '#e8f1f5',
        // background: #1e3c72; /* fallback for old browsers */
        // background: -webkit-linear-gradient(
        // to right,
        // #2a5298,
        // #1e3c72
        // ); /* Chrome 10-25, Safari 5.1-6 */
        // background: linear-gradient(
        // to right,
        // #2a5298,
        // #1e3c72
        // ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */,
    
        '& .logo-img': {
            maxHeight: '130px',
            '@media only screen and (max-width: 1500px)': {
                maxHeight: '100px',
            },
            '@media only screen and (max-width: 430px)': {
                maxHeight: '60px',
            },
        },
        '@media only screen and (max-width: 768px)': {
            paddingTop: '20px',
            paddingBottom: '15px',
            textAlign: 'center',
        },
        '@media only screen and (max-width: 380px)': {
            paddingTop: '15px',
            paddingBottom: '12px',
        },
    }
})

function Header() {

    var classes = useStyles()

    return (
        <header className={classes.header}>
            <div className="container">
                <img className="logo-img" src="/pitchbattle/images/nxgventures-pitch-battle-logo.png" alt="NXG Pitch Battle Logo"/>
            </div>
        </header>
    )
}

export default Header
